<template>
    <primevue-select-button
        :allowEmpty="false"
        :model-value="props.modelValue"
        :options="researchSelectionOptions"
        optionLabel="name"
        optionValue="id"
        @update:model-value="emit('update:modelValue', $event)"
    />
</template>

<script setup lang="ts">
import { authState } from '@lcp/http-auth';
import { computed } from 'vue';
import PrimevueSelectButton from 'primevue/selectbutton';
import { IIdName } from '@/interfaces/general/IIdName.ts';
import { ResearchSelectionType } from '@/interfaces/deltaGpt/IDeltaUserSettings.ts';

const props = defineProps<{
    modelValue: ResearchSelectionType;
}>();

const emit = defineEmits<{
    'update:modelValue': [ResearchSelectionType];
}>();

const RESEARCH_SELECTION_OPTIONS: Array<IIdName> = [
    { name: 'All', id: ResearchSelectionType.AllProducts },
    { name: 'Available to me', id: ResearchSelectionType.MyProducts },
    { name: 'Public', id: ResearchSelectionType.PublicProducts },
];

const researchSelectionOptions = computed<Array<IIdName>>(() => (
    authState.value.loggedIn
        ? RESEARCH_SELECTION_OPTIONS
        : RESEARCH_SELECTION_OPTIONS.filter(option => option.id !== ResearchSelectionType.MyProducts)
));
</script>
